import { useQuery } from '@apollo/client';
import { AutoCompleteSoftSkills } from '@components/AutoComplete/AutoCompleteSoftSkills';
import { AutoCompleteTalentSpecialties } from '@components/AutoComplete/AutoCompleteTalentSpecialties';
import InputMultiSelect from '@components/InputMultiSelect';
import { getTalentSpecialtiesQuery } from '@gql/talentSpecialties';
import { useOptionsContext } from '@modules/talents/context/options-context';
import { Card, CircularProgress, Stack } from '@mui/material';
import { groupBy } from 'lodash';
import { useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import InputSwitchControl from '@components/InputSwitchControl';
import InputLanguages from '@modules/JobOffers/forms/InputLanguages';

const JobOfferProfileWantedForm = () => {
    const { data: optionsData } = useOptionsContext();
    const options = useMemo(() => optionsData?.options, [optionsData]);
    const { control, getValues } = useFormContext();
    const values = getValues();
    const [allowFreshGrad, setAllowFreshGrad] = useState(values?.position?.allowFreshGrad);

    const { data: dataSpecialities, loading: loadingSpecialities } = useQuery(getTalentSpecialtiesQuery);

    const groupedSpecialties = groupBy(dataSpecialities?.specialities ?? [], 'groupName');

    if (loadingSpecialities) {
        return (
            <Stack
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                <CircularProgress />
            </Stack>
        );
    }

    return (
        <Card>
            <InputSwitchControl
                control={control}
                name="position.allowFreshGrad"
                defaultValue={values?.position?.allowFreshGrad}
                title="Débutant(e) accepté(e)"
                style={{ alignItems: 'center' }}
                onChange={val => {
                    setAllowFreshGrad(val);
                }}
            />

            <InputMultiSelect
                label="Nombre d'années d’expérience mini"
                placeholder="Sélectionnez l'expérience"
                items={options?.experiences}
                control={control}
                single
                name="position.experience"
                defaultValue={values?.position?.experience}
                required={allowFreshGrad === false}
            />
            
            <AutoCompleteTalentSpecialties
                allowAdd
                label="Compétences requises"
                placeholder={'Sélectionnez les compétences maîtrisées'}
                control={control}
                name="candidate.specialties"
                groupedOptions={Object.keys(groupedSpecialties).map(groupName => ({
                    name: groupName,
                    children: groupedSpecialties[groupName].map(item => ({
                        id: item._id,
                        name: item.name,
                        value: item._id,
                    })),
                }))}
            />
            <AutoCompleteSoftSkills
                allowAdd
                label="Savoir être"
                placeholder="Sélectionnez les savoir-être"
                control={control}
                name="candidate.softSkillIds"
                groupedOptions={options?.softSkills}
            />
            <Stack style={{ zIndex: 91 }}>
                <InputMultiSelect
                    label="Diplôme"
                    placeholder="Sélectionnez le diplôme"
                    items={options?.degreeOptions}
                    control={control}
                    name="candidate.degree"
                    defaultValue={values?.candidate?.degree}
                />
            </Stack>
            <InputLanguages />
        </Card>
    );
};

export default JobOfferProfileWantedForm;
